import styled from "styled-components";

export const StyledFooter = styled.footer`
	height: 50px;
	margin-top: auto;

	display: flex;
	align-items: center;
	justify-content: space-around;

	border-top: solid 2px #000;
`;

export const StyledFooterText = styled.span`
	font-size: ${(p) => p.theme.fontSizes.fs12};

	margin-right: 15px;

	@media (max-width: 420px) {
		margin-right: 0;
	}
`;

export const PositionBox = styled(StyledFooterText)`
	@media (max-width: 420px) {
		margin-bottom: 5px;
	}
`;
